/**
 * AGAB Custom JavaScript - Premium Interactions & Animations
 * Enhances the theme with smooth scroll effects, parallax, and dynamic elements
 */

(function() {
  'use strict';

  // ===== Scroll Progress Bar =====
  function initScrollProgress() {
    let progressBar = document.querySelector('.scroll-progress');
    
    if (!progressBar) {
      progressBar = document.createElement('div');
      progressBar.className = 'scroll-progress';
      document.body.appendChild(progressBar);
    }

    window.addEventListener('scroll', () => {
      const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (window.pageYOffset / windowHeight) * 100;
      progressBar.style.width = scrolled + '%';
    });
  }

  // ===== Scroll-triggered Animations =====
  function initScrollAnimations() {
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe elements with scroll animation classes
    document.querySelectorAll('.scroll-fade-in, .scroll-scale').forEach(el => {
      observer.observe(el);
    });

    // Add classes to sections automatically
    document.querySelectorAll('.section, .collection-card').forEach((el, index) => {
      el.classList.add('scroll-fade-in');
      el.style.transitionDelay = `${index * 0.1}s`;
    });
  }

  // ===== Parallax Effect =====
  function initParallax() {
    const parallaxElements = document.querySelectorAll('.parallax-bg, .hero-section::before');
    
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      
      parallaxElements.forEach(el => {
        const speed = el.dataset.speed || 0.5;
        el.style.transform = `translateY(${scrolled * speed}px)`;
      });
    });
  }

  // ===== Honeycomb Cursor Trail =====
  function initHoneycombTrail() {
    let lastTime = 0;
    const throttleDelay = 150;

    document.addEventListener('mousemove', (e) => {
      const currentTime = Date.now();
      
      if (currentTime - lastTime < throttleDelay) return;
      lastTime = currentTime;

      // Create honeycomb shape
      const honeycomb = document.createElement('div');
      honeycomb.style.cssText = `
        position: fixed;
        width: 20px;
        height: 20px;
        background: rgba(253, 185, 0, 0.4);
        clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
        pointer-events: none;
        z-index: 9999;
        left: ${e.clientX - 10}px;
        top: ${e.clientY - 10}px;
        animation: fadeOut 1s ease-out forwards;
      `;
      
      document.body.appendChild(honeycomb);
      
      setTimeout(() => honeycomb.remove(), 1000);
    });

    // Add fade out animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeOut {
        to {
          opacity: 0;
          transform: scale(0.5);
        }
      }
    `;
    document.head.appendChild(style);
  }

  // ===== Floating Honey Drops =====
  function addFloatingHoneyDrops() {
    const hero = document.querySelector('.hero-section, [class*="slideshow"]');
    if (!hero) return;

    for (let i = 0; i < 5; i++) {
      const drop = document.createElement('div');
      drop.className = 'honey-drop';
      drop.style.cssText = `
        top: ${Math.random() * 80}%;
        left: ${Math.random() * 90}%;
        animation-delay: ${Math.random() * 6}s;
      `;
      hero.style.position = 'relative';
      hero.appendChild(drop);
    }
  }

  // ===== Smooth Scroll for Anchor Links =====
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ===== Add Honey Drip Effect to Headers =====
  function addHoneyDripEffect() {
    const headers = document.querySelectorAll('h1, h2.section-header__heading');
    headers.forEach(header => {
      if (!header.classList.contains('honey-drip')) {
        header.classList.add('honey-drip');
      }
    });
  }

  // ===== Enhanced Product Card Interactions =====
  function enhanceProductCards() {
    const cards = document.querySelectorAll('.product-card, [class*="product-item"]');
    
    cards.forEach(card => {
      card.addEventListener('mouseenter', function() {
        this.style.zIndex = '10';
      });
      
      card.addEventListener('mouseleave', function() {
        this.style.zIndex = '1';
      });
    });
  }

  // ===== Sticky Header Enhancement =====
  function initStickyHeader() {
    const header = document.querySelector('.header, [class*="header"]');
    if (!header) return;

    let lastScroll = 0;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 100) {
        header.classList.add('header--sticky');
      } else {
        header.classList.remove('header--sticky');
      }
      
      lastScroll = currentScroll;
    });
  }

  // ===== Add Numbered Circles to Lists =====
  function enhanceNumberedLists() {
    const lists = document.querySelectorAll('.icon-text-blocks, [class*="icon-list"]');
    
    lists.forEach(list => {
      const items = list.querySelectorAll('[class*="block"], [class*="item"]');
      items.forEach((item, index) => {
        if (!item.querySelector('.number-circle')) {
          const circle = document.createElement('div');
          circle.className = 'number-circle';
          circle.textContent = index + 1;
          item.insertBefore(circle, item.firstChild);
          item.classList.add('numbered-feature');
        }
      });
    });
  }

  // ===== Add Bee Trail Animation =====
  function initBeeTrail() {
    const sections = document.querySelectorAll('.section:nth-child(even)');
    sections.forEach(section => {
      section.classList.add('bee-trail');
    });
  }

  // ===== Newsletter Form Enhancement =====
  function enhanceNewsletter() {
    const newsletter = document.querySelector('[class*="newsletter"]');
    if (!newsletter) return;

    const form = newsletter.querySelector('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        const button = this.querySelector('button[type="submit"]');
        if (button) {
          button.textContent = '🐝 Subscribing...';
          button.style.transform = 'scale(0.95)';
          
          setTimeout(() => {
            button.textContent = '✓ Subscribed!';
            button.style.background = '#4acb95';
          }, 1000);
        }
      });
    }
  }

  // ===== Add Section Dividers =====
  function addSectionDividers() {
    const sections = document.querySelectorAll('.shopify-section:not(.shopify-section-header):not(.shopify-section-group-header-group)');
    sections.forEach((section, index) => {
      // Skip header sections and only add dividers in main content
      // skip aside and footer sections if the element is <aside> or <footer></footer> 
      if (index > 0 && index < sections.length - 1 && !section.nextElementSibling?.classList.contains('section-divider') && section.tagName.toLowerCase() !== 'aside' && section.tagName.toLowerCase() !== 'footer') {
        const divider = document.createElement('div');
        divider.className = 'section-divider';
        section.after(divider);
      }
    });
  }

  // ===== Initialize All Functions =====
  function init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    console.log('🐝 AGAB Theme Enhancements Loading...');

    // Initialize all features
    setTimeout(() => {
      initScrollProgress();
      initScrollAnimations();
      initSmoothScroll();
      addHoneyDripEffect();
      enhanceProductCards();
      initStickyHeader();
      addFloatingHoneyDrops();
      initBeeTrail();
      enhanceNewsletter();
      addSectionDividers();
      
      // Optional: Enable parallax (can be heavy on mobile)
      if (window.innerWidth > 768) {
        initParallax();
        // initHoneycombTrail(); // Uncomment for cursor trail effect
      }

      console.log('✓ AGAB Theme Enhancements Active!');
    }, 100);
  }

  // Start initialization
  init();

  // Re-init on page transitions (for AJAX navigation)
  document.addEventListener('shopify:section:load', init);

})();
